const FormTexts = {
    en: {},
    lt: {
        translation: {
            forms: {
                "first_name": "Vardas",
                "last_name": "Pavardė",
                "spouse_email": "Sutuoktinio el. pašto adresas",
                "email": "El. pašto adresas",
                "spouse_phone": "Sutuoktinio telefono numeris",
                "phone": "Telefono numeris",
                "agreement": "<0>Sutinku su </0><1>Kliento duomenų tvarkymo principais</1> ir <3>svetainės naudojimosi taisyklėmis </3>",
                "next": "Toliau",
                "agree": "Sutinku",
                "save": "Išsaugoti",

                "personal_code": "Asmens kodas",
                "monthly_income": "Jūsų mėn pajamos (neto),  €",
                "monthly_income_family": "Jūsų ir Jūsų sutuoktinio pajamos kartu sudėjus (Neto),  €",
                "do_you_know": "Ar jums yra žinoma aplinkybių, dėl kurių gali mažėti jūsų (jūsų šeimos) pajamos?",
                "family_do_you_know": "Ar jums yra žinomų priežasčių, dėl kurių gali keistis jūsų šeimos pajamos?",
                "enter_future_incomes": "Jei manote, jog ateityje keisis Jūsų pajamos, vertinimui pateikite tas, kurios bus pasikeitus.",
                "enter_expected_income": "Įveskite savo numatomas mėnesio pajamas",
                "yes": "Taip",
                "no": "Ne",
                "has_liabilities": "Pažymėkite varnelę, jeigu turite įsipareigojimų finansinėms institucijoms.",
                "your_credit_liabilities": "Jūsų vartojimo paskolų įmoka",
                "your_mortgage_liabilities": "Jūsų būsto paskolų įmoka",
                "your_other_liabilities": "Kiti jūsų finansiniai įsipareigojimai*",
                "eur_per_month": " €/mėn",
                "liabilities_explanation": "*Nereikia vesti namų ūkio išlaidų, pvz., mokesčiai už komunalines paslaugas, transporto išlaidos ir kt.",

                "consent_text": "Sutinku, kad Bendrovė tiesioginės rinkodaros tikslu tvarkytų mano asmens duomenis, įskaitant vardą, pavardę, gimimo datą, gyvenamosios vietos adresą ir teirautųsi nuomonės dėl teikiamų paslaugų ar teiktų komercinius pasiūlymus.",
                "i_agree_to_get": "Sutinku gauti Inbank pasiūlymus:",
                "by_phone": "Telefonu",
                "by_snail_mail": "Paštu",
                "by_email": "Elektroniniu paštu",
                "by_social_media": "Socialiniais tinklais ir pan.",
                "spouse_consent": "Sutinku, kad tuo atveju, kai į Inbank kreipsis mano sutuoktinis, kreditingumo vertinimo tikslais dėl sutarčių šeimos poreikiams tenkinti sudarymo, Inbank gali 3 (trejus) metus nuo šio sutikimo davimo dienos, kreiptis į išorines duomenų bazes ir panaudoti jau turimus mano asmens duomenis.",
                "sign_consent": "Pasirašyti anketą",

                "sign_by_1_ct": "Per el. bankininkystę",
                "sign_by_esign": "M. parašu",
                "sign_by_smart_id": "Smart-ID",
                "have_questions": "Turite klausimų? Į juos atsakysime numeriu <1>+370 700 700 80</1>",
                "waiting_bank_response": "Laukiame patvirtinimo, jog dokumentas pasirašytas",

                "account": "Jūsų sąskaitos nr. į kurią pervesime pinigus",
                "address": "Jūsų adresas",
                "address_example": "Pvz.: Kareivių g. 100B, Vilnius",
                "subj_doc_type": "Asmens tapatybę patvirtinantis dokumentas",
                "subj_doc_number": "Dokumento numeris",
                "subj_doc_issue_dt": "Dokumento išdavimo data",
                "subj_doc_exp_dt": "Dokumento galiojimo terminas",
                "occupation_info": "Informacija apie Jūsų pajamų šaltinį",
                "working_place": "Darbovietės pavadinimas",
                "position": "Einamos pareigos",
                "i_am_iban_owner": "Patvirtinu, kad pats naudosiuos finansinėmis paslaugomis ir/ar esu tikrasis sąskaitos savininkas (naudos gavėjas).",

                "sign_contract": "Pasirašyti sutartį",
                "download_contract": "Parsisiųsti sutartį",
                "open_in_new_tab": "Peržiūrėti kitame lange",

                "congratulations": "Sveikiname sudarius sutartį!",
                "you_can_find_info_on_site": "Jums aktualią informaciją apie vartojimo kreditą rasite prisiregistravę prie savitarnos",
                "sign_up_btn": "Registruotis",
                "i_have_read": "Susipažinau su ",
                "privacy_policy": "privatumo politika",
                "password": "Slaptažodis",
                "password_help_text": "Slaptažodis turi būti bent 6 simbolių ilgio. Jame privalo būti bent viena didžioji raidė, mažoji raidė, skaitmuo bei specialusis simbolis",
                "password_confirmation": "Pakartokite slaptažodį",
                "via_email": "El. paštu",
                "via_msign": "Mobiliu parašu",
                "via_smartid": "Smart-ID",
                "login": "Prisijungti",
                "forgot_password": "Pamiršote slaptažodį?",
                "expired_password": "Dėl atnaujintų apsaugos sistemų, klientų prašome pakeisti slaptažodį.",
                "forgot_password_explanation": "Įveskite registracijos formoje nurodytą el. pašto adresą ir visą informaciją kaip pasikeisti slaptažodį išsiųsime Jūsų nurodytu el. paštu.",
                "continue_btn": "Tęsti",
                "reset_password": "Slaptažodžio keitimas",
                "reset_password_explanation": "Įveskite naują slaptažodį, kuriuo nuo šiol jungsitės prie Savitarnos portalo.",
                "signin_timeout": "Jūsų patvirtinimo laikas baigėsi. Prašome bandyti dar kartą",
                "signin_check_code_reminder": "Prašome patikrinti, ar dabar Jūsų telefono ekrane matomas kontrolinis kodas sutampa su šiuo kodu:",
                "awaiting_for_your_confirmation": "Laukiame Jūsų patvirtinimo:",

                "other_amount": "Kita paskolos suma",
                "loan_amount": "Paskolos suma",
                "choose_term": "Pasirinkite terminą",
                "monthly_payment": "Mėnesio įmoka",
                "create_contract": "Sudaryti paskolos sutartį",
                "are_you_a_politician": "Nurodykite ar Jūs arba Jūsų artimieji šeimos nariai, ar artimi pagalbininkai eina, ar ne anksčiau negu prieš vienus metus ėjo svarbias viešąsias pareigas LR, ES, tarptautinėse ar užsienio valstybių institucijose per vienerius metus.",

                "not_iban_owner_error": "Deja, tęsti negalima.",

                "politician": {
                    "full_name": "Vardas, pavardė",
                    "pep_position_type": "PEP pareigų tipas",
                    "country": "Valstybė",
                    "institution": "Institucija",
                    "position": "PEP pareigų pavadinimas",

                    "describe_relationship": "Nurodykite ryšius su šiuo asmeniu:",
                    "politician_me": "Esu pats",
                    "politician_family": "Artimas šeimos narys",
                    "politician_associate": "Artimas pagalbininkas"
                },
                "representative_data": {
                    "full_name": "Vardas, pavardė",
                    "code": 'Asmens kodas',
                    "cntr_reg": "Pilietybė",
                    "phone": "Tel. numeris",
                    "email": "El. paštas",
                    "address": "Adresas",
                    "birth_dt": "Gimimo data",
                    "doc_type": "Dokumento tipas",
                    "doc_number": "Dokumento numeris",
                    "doc_issue_dt": "Dokumento išdavimo data",
                    "doc_exp_dt": "Dokumento galiojimo terminas",
                    "auth_doc_number": "Įgaliojimo numeris",
                    "auth_doc_exp_dt": "Galiojimo terminas",
                },
                "loan_list": {
                    "agreement": "Sutartis",
                    "date": "Data",
                    "amount": "Suma",
                    "period": "Terminas",
                    "monthly_payment": "Mėnesio įmoka",
                    "agreement_no": "Sutaries numeris:",
                    "small_loan": "Paskola",
                },
                "months_short": "mėn.",
                "no_loans_yet": "Inbank paskolų neturite",
                "sign": {
                    "smartId": "Pasirašyti su Smart-ID",
                    "msign": "Pasirašyti su m. parašu"
                },
                "mark_all": "Pažymėti visus",
                "liabilities_tooltip": "Įsipareigojimai bankams, unijoms ir kitoms finansų įstaigoms per mėn.",
                "know_bonus_code": "Pažymėkite varnelę, jeigu turite nuolaidos kodą",
                "bonus_code": "Nuolaidos kodas",
                "try_again": "Bandyti dar kartą",
                "spouse_consent_link_sent": "Nuoroda į Kliento anketą Jūsų sutuoktiniui buvo sėkmingai išsiųsta. Kai ji bus pasirašyta, atliksime Jūsų šeimos finansinį vertinimą ir pateiksime galimus finansavimo variantus.",
                "begin_btn": "Pradėti",
                "document_signed_successfully_msg": "Ačiū, dokumentas buvo sėkmingai pasirašytas",
                "act_field": "Nurodykite sritį",
                "other_desc": "Kokia tai veikla",

                "sign_document": "Pasirašyti dokumentą",
                "documents_were_signed_successfully": "Dėkojame, dokumentai buvo sėkmingai pasirašyti!",

                'input_address': {
                    "placeholder": "Įveskite savo tikslų adresą",
                    "error": "Pasirinkite adresą iš sąrašo."
                },
            }
        },
    },
};

export default FormTexts;
